<section class="expire-list">
  <div class="clearfix">
    <h5 class="float-start mb-0">{{'ui.expiring-soon'|translate}}</h5>
    <button type="button" class="btn btn-sm btn-link float-end p-0" (click)="showPriceAgreements()">
      {{'ui.go-to'|translate }} {{'financial.price-agreements'|translate}}
      <i class="fa fa-arrow-right"></i>
    </button>
  </div>
  <div *ngIf="sortedAgreements.length; else noAgreements" class="table-responsive mt-2">
    <table class="table table-sm table-borderless mb-0">
      <thead>
        <tr>
          <td class="ps-0">Type</td>
          <td>Klant / Werk</td>
          <td class="ps-0">Omschrijving</td>
          <td class="days-column text-end">Resterend</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let agreement of sortedAgreements; trackBy: trackByAgreementId">
          <td class="ps-0">
            <span *ngIf="agreement.subjectType === SubjectType.Customer">Klant</span>
            <span *ngIf="agreement.subjectType === SubjectType.Project">Werk</span>
          </td>
          <td>
            <jbm-link-button
              [caption]="agreement.subjectName"
              [showIcon]="false"
              (onClick)="showSubject(agreement)">
            </jbm-link-button>
          </td>
          <td class="description-column ps-0">
            {{agreement.description}}
          </td>
          <td class="w-5rem text-end">
            <span class="badge w-100" [ngClass]="getUrgencyClass(agreement.daysUntilExpiration)">
              {{agreement.daysUntilExpiration}} dagen
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #noAgreements>
    <jbm-empty-view [emptyView]="true"></jbm-empty-view>
  </ng-template>
</section>
